module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_j_leucistic.5eaa7453.png";